import React from 'react';
import { FaHeartbeat, FaUserMd, FaStethoscope, FaMobileAlt } from 'react-icons/fa';

const features = [
  {
    icon: FaHeartbeat,
    title: "AI-Powered Symptom Analysis",
    description: "Our advanced AI algorithms analyze your symptoms with high accuracy, comparing them with millions of medical records to provide reliable health insights within seconds."
  },
  // {
  //   icon: FaUserMd,
  //   title: "Personalized Treatment Plans",
  //   description: "Receive customized treatment recommendations based on your unique health profile, medical history, and specific condition requirements."
  // },
  {
    icon: FaStethoscope,
    title: "Early Disease Detection",
    description: "Our system can identify potential health issues before they become serious problems, enabling preventative care and early intervention."
  },
  {
    icon: FaMobileAlt,
    title: "24/7 Virtual Consultations",
    description: "Connect with healthcare professionals anytime, anywhere through our secure platform for immediate medical advice and guidance."
  }
];

const waveStyle1 = {
  animation: 'waveUpDown1 4s ease-in-out infinite alternate'
};

const waveStyle2 = {
  animation: 'waveUpDown2 7s ease-in-out infinite alternate'
};

const waveStyle3 = {
  animation: 'waveUpDown3 5s ease-in-out infinite alternate'
};
const Features = () => {
  return (
    <section id="features" className="py-24 ">
 
      <div className=" mx-auto px-4 max-w-7xl">
     
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600">Cutting-Edge Features</span>
          </h2>
          <div className="w-24 h-1 mx-auto bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover how our innovative healthcare technology is transforming patient care
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 border border-gray-100 relative overflow-hidden group"
            >
              <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-blue-500 to-indigo-600"></div>

              <div className="mb-8 relative">
                <div className="absolute inset-0 bg-blue-100 rounded-full w-16 h-16 -z-10 group-hover:scale-110 transition-transform duration-300"></div>
                <feature.icon className="text-blue-600 text-4xl" />
              </div>

              <h3 className="text-xl font-bold text-gray-800 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>

              <div className="mt-6 flex items-center text-blue-600 font-medium group-hover:text-blue-700 transition-colors">
                <span>Learn more</span>
                <svg className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="#services"
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Explore All Services
          </a>
        </div>
      </div>
    </section>
  );
};

export default Features;
